import { Pagination, Stack } from '@mui/material';

export const TimesheetPagination = (props) => {
  return (
    <Stack
      sx={
        props.noRecord
          ? { display: 'none' }
          : { display: 'flex', alignItems: 'center', mb: 'auto' }
      }
      spacing={2}
    >
      <Pagination
        variant="outlined"
        shape="rounded"
        page={props.page}
        count={props.count}
        onChange={props.onChange}
        size="large"
      />
    </Stack>
  );
};
